import { EPostsActions, PostActions } from '../actions/posts.actions';
import { initialPostsState, PostsState } from '../states/posts.state';

export function postsReducers(
  state = initialPostsState,
  action: PostActions
): PostsState {
  switch (action.type) {
    case EPostsActions.GetPostSuccess: {
      return {
        ...state,
        posts: action.payload
      };
    }

    case EPostsActions.GetPostFailure: {
      return {
        ...state,
        posts: null
      };
    }

    default:
      return state;
  }
}
